import AirDatepicker from 'air-datepicker'
import 'air-datepicker/air-datepicker.css'

new AirDatepicker('#user_date', {
	minDate: new Date(new Date().getTime() + 24 * 60 * 60 * 1000),
	classes: 'dark'
});
